'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ChatPanel} from '../ChatPanel';
import {I18nMessage} from '../../../components/I18nMessage';
import {StatefulButton} from '../../../components/buttons/StatefulButton';
import {isButtonState} from '../../../core-utilities/enums/ButtonState';

// TODO: setup settings options
export function ChatListSettingsView(props) {
  return (
    <ChatPanel
      className={classNames("ChatListSettings", props.className)}
      headerLabel={<I18nMessage message="comments.settings.label" />}
      onClose={props.onClose}
      onHidePanel={props.onHidePanel}
    >
      <div className="ChatListSettings__body">
        <label className={classNames("ChatListSettings__fieldTitle")}>
          <I18nMessage message={props.isSubscribed ? "comments.unsubscribe.message" : "comments.subscribe.message"} />
        </label>
        <StatefulButton
          className="ChatListSettings__button"
          usePropState={true}
          mode={props.updateSubscriptionMode}
          startLabel={<I18nMessage
            message={props.isSubscribed ? "comments.unsubscribe.label" : "comments.subscribe.label"}
          />}
          onClick={props.onChangeSubscription}
        />
      </div>
    </ChatPanel>
  );
}

ChatListSettingsView.propTypes = {
  className: T.string,
  channelId: T.string,
  isSubscribed: T.bool,
  updateSubscriptionMode: isButtonState,
  onChangeSubscription: T.func.isRequired,
};

ChatListSettingsView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/comments/components/ChatListSettings/ChatListSettingsView.js